import { render } from "./StudentsGrantsNutritionView.vue?vue&type=template&id=76e5f211&scoped=true"
import script from "./StudentsGrantsNutritionView.vue?vue&type=script&lang=js"
export * from "./StudentsGrantsNutritionView.vue?vue&type=script&lang=js"

import "./StudentsGrantsNutritionView.vue?vue&type=style&index=0&id=76e5f211&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e5f211"]])

export default __exports__